document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname.includes("/cart")) {
    return;
  }

  // ========== INICIALIZAR QUANTITY SELECTORS ==========
  initializeQuantitySelectors();

  // ========== INICIALIZAR VARIANT PICKERS ==========
  initializeVariantPickers();

  // ========== ESCUCHAR CAMBIOS DE VARIANTE ==========
  initializeVariantListeners();

  // ========== EVENT LISTENER ÚNICO PARA ADD TO CART ==========
  document
    .querySelectorAll('form[data-type="add-to-cart-form"]')
    .forEach(function (form) {
      // 🔧 FIX 1: Prevenir múltiples event listeners en el mismo form
      if (form.dataset.listenerAttached === 'true') {
        return;
      }
      form.dataset.listenerAttached = 'true';
      
      form.addEventListener("submit", function (e) {
        e.preventDefault();

        const formData = new FormData(form);
        const variantId = formData.get("id");
        
        // Obtener la cantidad del input
        const quantityInput = form.querySelector('.quantity-input');
        const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

        if (!variantId) {
          console.error("No se encontró un ID de variante válido.");
          showAddToCartError("Por favor selecciona todas las opciones del producto.");
          return;
        }

        // Mostrar loading en el botón
        const submitButton = form.querySelector('button[type="submit"]');
        const spinner = submitButton.querySelector('.loading-overlay__spinner');
        const buttonText = submitButton.querySelector('.add-to-cart-text');
        
        // 🔧 FIX 2: Prevenir múltiples clicks mientras está procesando
        if (submitButton.dataset.processing === 'true') {
          return;
        }
        submitButton.dataset.processing = 'true';
        
        // Guardar estado original del botón
        const originalStyles = {
          background: submitButton.style.background || getComputedStyle(submitButton).backgroundColor,
          color: submitButton.style.color || getComputedStyle(submitButton).color,
          border: submitButton.style.border || getComputedStyle(submitButton).border,
          text: buttonText ? buttonText.textContent : 'Agregar al carrito'
        };
        
        submitButton.disabled = true;
        if (spinner) spinner.classList.remove('hidden');

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
         
            // Animación de éxito del botón
            showButtonSuccessAnimation(submitButton, buttonText, originalStyles);
            
            // Reiniciar contador de cantidad
            resetQuantitySelector(form);
            
            // Mostrar toast de éxito
            showCartToast();
            
            // Mostrar notificación de éxito
            showAddToCartSuccess(quantity);

            return fetch("/cart.js");
          })
          .then((res) => res.json())
          .then((cart) => {
            updateCartBubble(cart);
          })
          .catch((err) => {
            console.error("Error al agregar al carrito:", err);
            showAddToCartError();
            // 🔧 FIX 3: Rehabilitar el botón en caso de error
            submitButton.disabled = false;
            submitButton.dataset.processing = 'false';
          })
          .finally(() => {
            // Ocultar spinner
            if (spinner) spinner.classList.add('hidden');
          });

      });
    });
});

// ========== FUNCIONES DE VARIANT PICKER INTEGRADO ==========
function initializeVariantPickers() {
  const variantPickers = document.querySelectorAll('.variant-picker');
  
  variantPickers.forEach(function(picker) {
    const productForm = picker.closest('product-form');
    if (!productForm) return;
    
    // Inicializar la primera variante seleccionada
    updateSelectedVariantFromPicker(productForm);
  });
}

function initializeVariantListeners() {
  // Escuchar cambios en los selects de variante integrados
  document.querySelectorAll('.variant-select').forEach(function(select) {
    select.addEventListener('change', function() {
      const productForm = this.closest('product-form');
      if (productForm) {
        updateSelectedVariantFromPicker(productForm);
      }
    });
  });

  // Escuchar cambios en los radio buttons de variante integrados
  document.querySelectorAll('.variant-radio').forEach(function(input) {
    input.addEventListener('change', function() {
      const productForm = this.closest('product-form');
      if (productForm) {
        updateSelectedVariantFromPicker(productForm);
      }
    });
  });

  // Mantener compatibilidad con variant pickers externos
  document.querySelectorAll('select[name^="options"]').forEach(function(select) {
    if (!select.classList.contains('variant-select')) {
      select.addEventListener('change', function() {
        updateSelectedVariant(this);
      });
    }
  });

  document.querySelectorAll('input[name^="options"]').forEach(function(input) {
    if (!input.classList.contains('variant-radio')) {
      input.addEventListener('change', function() {
        updateSelectedVariant(this);
      });
    }
  });
}

function updateSelectedVariantFromPicker(productForm) {
  if (!productForm) return;

  const productId = productForm.dataset.productId;
  if (!productId) return;

  // Obtener todas las opciones seleccionadas del picker integrado
  const selectedOptions = [];
  
  // Obtener opciones de selects
  const selects = productForm.querySelectorAll('.variant-select');
  selects.forEach(function(select) {
    selectedOptions.push(select.value);
  });
  
  // Obtener opciones de radio buttons
  const checkedRadios = productForm.querySelectorAll('.variant-radio:checked');
  checkedRadios.forEach(function(radio) {
    selectedOptions.push(radio.value);
  });

  // Si no hay opciones seleccionadas, usar los valores por defecto
  if (selectedOptions.length === 0) {
    const allSelects = productForm.querySelectorAll('.variant-select');
    const allRadios = productForm.querySelectorAll('.variant-radio');
    
    allSelects.forEach(function(select) {
      selectedOptions.push(select.value);
    });
    
    // Para radio buttons, tomar el primero de cada grupo
    const radioGroups = {};
    allRadios.forEach(function(radio) {
      const groupName = radio.name;
      if (!radioGroups[groupName]) {
        radioGroups[groupName] = radio.value;
        radio.checked = true;
      }
    });
    
    Object.values(radioGroups).forEach(function(value) {
      selectedOptions.push(value);
    });
  }

  // Encontrar la variante que coincide con las opciones seleccionadas
  const variantData = getVariantData(productForm);
  if (!variantData) return;

  const matchingVariant = findMatchingVariant(variantData.variants, selectedOptions);
  
  if (matchingVariant) {
    updateVariantInForm(matchingVariant, productForm);
    updateVariantPickerAvailability(productForm, variantData.variants, selectedOptions);
  }
}

function updateVariantPickerAvailability(productForm, variants, currentSelection) {
  // Esta función actualiza la disponibilidad de opciones en el picker
  // basándose en las combinaciones disponibles
  
  const variantPicker = productForm.querySelector('.variant-picker');
  if (!variantPicker) return;
  
  // Obtener todos los grupos de opciones
  const optionGroups = variantPicker.querySelectorAll('.variant-option-group');
  
  optionGroups.forEach(function(group, optionIndex) {
    const inputs = group.querySelectorAll('.variant-select, .variant-radio');
    
    inputs.forEach(function(input) {
      const testSelection = [...currentSelection];
      testSelection[optionIndex] = input.value;
      
      // Verificar si existe una variante con esta combinación
      const hasAvailableVariant = variants.some(function(variant) {
        return variant.available && 
               variant.options.every(function(option, index) {
                 return index >= testSelection.length || option === testSelection[index];
               });
      });
      
      // Actualizar el estado del input
      if (input.type === 'radio') {
        const label = group.querySelector(`label[for="${input.id}"]`);
        if (label) {
          if (hasAvailableVariant) {
            input.disabled = false;
            label.classList.remove('unavailable');
          } else {
            input.disabled = true;
            label.classList.add('unavailable');
          }
        }
      } else if (input.tagName === 'SELECT') {
        const options = input.querySelectorAll('option');
        options.forEach(function(option) {
          if (option.value === input.value) return; // No deshabilitar la opción actual
          
          const testValue = [...currentSelection];
          testValue[optionIndex] = option.value;
          
          const isAvailable = variants.some(function(variant) {
            return variant.available && 
                   variant.options.every(function(opt, idx) {
                     return idx >= testValue.length || opt === testValue[idx];
                   });
          });
          
          option.disabled = !isAvailable;
        });
      }
    });
  });
}

// ========== FUNCIONES DE VARIANT PICKER LEGACY (compatibilidad) ==========
function updateSelectedVariant(changedElement) {
  // Mantener compatibilidad con variant pickers externos
  const productForm = changedElement.closest('product-form') || changedElement.closest('[data-product-id]');
  if (!productForm) return;

  const productId = productForm.dataset.productId;
  if (!productId) return;

  // Obtener todas las opciones seleccionadas
  const selectedOptions = [];
  const optionElements = productForm.querySelectorAll('select[name^="options"], input[name^="options"]:checked');
  
  optionElements.forEach(function(element) {
    if (element.type === 'radio' || element.type === 'checkbox') {
      if (element.checked) {
        selectedOptions.push(element.value);
      }
    } else {
      selectedOptions.push(element.value);
    }
  });

  // Encontrar la variante que coincide con las opciones seleccionadas
  const variantData = getVariantData(productForm);
  if (!variantData) return;

  const matchingVariant = findMatchingVariant(variantData.variants, selectedOptions);
  
  if (matchingVariant) {
    updateVariantInForm(matchingVariant, productForm);
  }
}

function getVariantData(productForm) {
  const variantScript = productForm.querySelector('.product-variants-json');
  if (!variantScript) return null;
  
  try {
    return JSON.parse(variantScript.textContent);
  } catch (e) {
    console.error('Error parsing variant data:', e);
    return null;
  }
}

function findMatchingVariant(variants, selectedOptions) {
  return variants.find(function(variant) {
    return variant.options.every(function(option, index) {
      return option === selectedOptions[index];
    });
  });
}

function updateVariantInForm(variant, productForm) {
  // Actualizar el input hidden con el ID de la variante
  const variantIdInput = productForm.querySelector('.variant-id-input');
  if (variantIdInput) {
    variantIdInput.value = variant.id;
  }

  // Actualizar el botón de agregar al carrito
  const submitButton = productForm.querySelector('button[type="submit"]');
  const buttonText = submitButton ? submitButton.querySelector('.add-to-cart-text') : null;
  const soldOutMessage = submitButton ? submitButton.querySelector('.sold-out-message') : null;

  if (submitButton) {
    if (variant.available) {
      submitButton.disabled = false;
      // 🔧 FIX 4: Asegurar que el estado de procesamiento se limpia
      submitButton.dataset.processing = 'false';
      submitButton.classList.remove('sold-out');
      if (buttonText) {
        buttonText.textContent = buttonText.dataset.addToCartText || 'Agregar al carrito';
      }
      if (soldOutMessage) {
        soldOutMessage.classList.add('hidden');
      }
    } else {
      submitButton.disabled = true;
      submitButton.dataset.processing = 'false';
      submitButton.classList.add('sold-out');
      if (buttonText) {
        buttonText.textContent = buttonText.dataset.soldOutText || 'Agotado';
      }
      if (soldOutMessage) {
        soldOutMessage.classList.remove('hidden');
      }
    }
  }

  // Disparar evento personalizado para otros componentes
  const changeEvent = new CustomEvent('variant:updated', {
    detail: { variant: variant },
    bubbles: true
  });
  productForm.dispatchEvent(changeEvent);
}

// ========== FUNCIONES DE QUANTITY SELECTOR ==========
function updateQuantity(button, change) {
  const quantitySelector = button.closest('.quantity-selector');
  const input = quantitySelector.querySelector('.quantity-input');
  const minusBtn = quantitySelector.querySelector('.quantity-btn--minus');
  const plusBtn = quantitySelector.querySelector('.quantity-btn--plus');
  
  let currentValue = parseInt(input.value) || 1;
  let newValue = currentValue + change;
  
  // Obtener los límites del input
  const min = parseInt(input.getAttribute('min')) || 1;
  const max = parseInt(input.getAttribute('max')) || 99;
  
  // Validar los límites
  if (newValue < min) {
    newValue = min;
  } else if (newValue > max) {
    newValue = max;
  }
  
  // Actualizar el valor
  input.value = newValue;
  
  // Actualizar el estado de los botones
  minusBtn.disabled = newValue <= min;
  plusBtn.disabled = newValue >= max;
  
  // Agregar efecto visual al botón presionado
  button.style.transform = 'scale(0.95)';
  setTimeout(() => {
    button.style.transform = '';
  }, 100);
  
  // Disparar evento change para compatibilidad
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function initializeQuantitySelectors() {
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  
  quantitySelectors.forEach(function(selector) {
    const input = selector.querySelector('.quantity-input');
    const minusBtn = selector.querySelector('.quantity-btn--minus');
    const plusBtn = selector.querySelector('.quantity-btn--plus');
    
    if (input && minusBtn && plusBtn) {
      const currentValue = parseInt(input.value) || 1;
      const min = parseInt(input.getAttribute('min')) || 1;
      const max = parseInt(input.getAttribute('max')) || 99;
      
      // Estado inicial de los botones
      minusBtn.disabled = currentValue <= min;
      plusBtn.disabled = currentValue >= max;
      
      // Manejar cambios directos en el input (si se permite edición)
      input.addEventListener('input', function() {
        let value = parseInt(this.value) || min;
        
        if (value < min) value = min;
        if (value > max) value = max;
        
        this.value = value;
        minusBtn.disabled = value <= min;
        plusBtn.disabled = value >= max;
      });
    }
  });
}

// ========== FUNCIONES DE UI ==========
function showCartToast() {
  const toast = document.getElementById("cart-toast");
  if (toast) {
    toast.style.display = "block";
    toast.style.opacity = "1";

    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => {
        toast.style.display = "none";
      }, 500);
    }, 1500);
  }
}

function updateCartBubble(cart) {
  let countBubble = document.querySelector(".cart-count-bubble");

  if (!countBubble && cart.item_count > 0) {
    // Si no existe, crearla desde cero
    countBubble = document.createElement("div");
    countBubble.className = "cart-count-bubble";
    countBubble.innerHTML = `
      <span aria-hidden="true">${cart.item_count}</span>
      <span class="visually-hidden">${cart.item_count} artículos en el carrito</span>
    `;
    document
      .querySelector(".header__icon--cart")
      ?.appendChild(countBubble);
  } else if (countBubble) {
    const visibleCount = countBubble.querySelector('span[aria-hidden="true"]');
    const hiddenLabel = countBubble.querySelector(".visually-hidden");

    if (visibleCount) visibleCount.textContent = cart.item_count;
    if (hiddenLabel)
      hiddenLabel.textContent = `${cart.item_count} artículos en el carrito`;

    countBubble.style.display = cart.item_count > 0 ? "block" : "none";
  }
}

function showAddToCartSuccess(quantity) {
  // Verificar si ya existe una notificación para evitar duplicados
  const existingNotification = document.querySelector('.cart-notification');
  if (existingNotification) {
    existingNotification.remove();
  }

  const notification = document.createElement('div');
  notification.className = 'cart-notification success';
  notification.innerHTML = `
    <div class="cart-notification__content">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M7 10L9 12L13 8M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>¡${quantity} producto${quantity > 1 ? 's' : ''} agregado${quantity > 1 ? 's' : ''} al carrito!</span>
    </div>
  `;
  
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: white;
    border: 1px solid #10B981;
    border-radius: 8px;
    padding: 12px 16px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    animation: slideIn 0.3s ease-out;
    transform: translateX(0);
    opacity: 1;
  `;
  
  // Agregar estilos de animación al head si no existen
  if (!document.querySelector('#cart-notification-styles')) {
    const style = document.createElement('style');
    style.id = 'cart-notification-styles';
    style.textContent = `
      @keyframes slideIn {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      @keyframes slideOut {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(100%);
          opacity: 0;
        }
      }
      .variant-pill.unavailable {
        opacity: 0.5;
        cursor: not-allowed;
        background: #f5f5f5;
        text-decoration: line-through;
      }
    `;
    document.head.appendChild(style);
  }
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease-in';
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 300);
  }, 3000);
}

function showAddToCartError(customMessage) {
  const existingNotification = document.querySelector('.cart-notification');
  if (existingNotification) {
    existingNotification.remove();
  }

  const notification = document.createElement('div');
  notification.className = 'cart-notification error';
  notification.innerHTML = `
    <div class="cart-notification__content">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z" stroke="#EF4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>${customMessage || 'Error al agregar al carrito. Inténtalo de nuevo.'}</span>
    </div>
  `;
  
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: white;
    border: 1px solid #EF4444;
    border-radius: 8px;
    padding: 12px 16px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    animation: slideIn 0.3s ease-out;
  `;
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease-in';
    setTimeout(() => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    }, 300);
  }, 3000);
}


// Función para animar el botón cuando se agrega al carrito
function showButtonSuccessAnimation(submitButton, buttonText, originalStyles) {
  // Agregar clase de éxito
  submitButton.classList.add('success-state');
  
  if (buttonText) {
    buttonText.textContent = '¡Producto agregado!';
  }
  
  // Volver al estado original después de 2 segundos
  setTimeout(() => {
    submitButton.classList.remove('success-state');
    
    if (buttonText) {
      buttonText.textContent = originalStyles.text;
    }
    
    // 🔧 FIX 5: Rehabilitar el botón correctamente
    submitButton.disabled = false;
    submitButton.dataset.processing = 'false';
  }, 2000);
}

// Función para reiniciar el contador de cantidad
function resetQuantitySelector(form) {
  const quantityInput = form.querySelector('.quantity-input');
  const quantitySelector = form.querySelector('.quantity-selector');
  
  if (quantityInput && quantitySelector) {
    const minValue = parseInt(quantityInput.getAttribute('min')) || 1;
    quantityInput.value = minValue;
    
    // Actualizar estado de los botones
    const minusBtn = quantitySelector.querySelector('.quantity-btn--minus');
    const plusBtn = quantitySelector.querySelector('.quantity-btn--plus');
    const maxValue = parseInt(quantityInput.getAttribute('max')) || 99;
    
    if (minusBtn) minusBtn.disabled = minValue <= minValue;
    if (plusBtn) plusBtn.disabled = minValue >= maxValue;
  }
}